import React, { useState } from 'react';
import moment from 'moment';
import { Modal } from 'react-bootstrap';

import EmployeeModal from '~/components/pages/EmployeeList/EmployeeModal';
import EmployeeDetailsModal from '~/components/pages/EmployeeList/EmployeeDetailsModal';
import informationIcon from '~/assets/images/information.svg';
import editIcon from '~/assets/images/edit.svg';
import closeIcon from '~/assets/images/close-employee.svg';
import {
  Container,
  EmployeeName,
  DetailsContainer,
  SubDetailsContainer,
  DetailBadge,
  DateContainer,
  DateLabel,
  Date,
  ActionButton,
} from './styles';
import InativeModal from '../InativeModal';

function Item({ employeeData, employeeName, registerDate, status }) {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showInativeModal, setShowInativeModal] = useState(false);

  return (
    <Container>
      <EmployeeName>{employeeName}</EmployeeName>
      <DetailsContainer>
        <DateContainer>
          {status ? (
            <>
              <DateLabel>Data cadastro</DateLabel>
              <Date>{moment(registerDate).format('DD/MM/YYYY')}</Date>
            </>
          ) : (
            <>
              <DateLabel style={{ color: '#ffffff' }}>Data cadastro</DateLabel>
              <Date style={{ color: '#ffffff' }}>
                {moment(registerDate).format('DD/MM/YYYY')}
              </Date>
            </>
          )}
        </DateContainer>
        <SubDetailsContainer>
        {status && (
          <ActionButton onClick={() => setShowEditModal(true)}>
            <img src={editIcon} alt="edit icon" />
            <span>Editar</span>
          </ActionButton>
        )}
        {status && (
          <ActionButton onClick={() => setShowInativeModal(true)}>
            <img src={closeIcon} alt="close icon" />
            <span>Inativar</span>
          </ActionButton>
        )}
        <DetailBadge onClick={() => setShowDetailsModal(true)}>
          Detalhes
          <img src={informationIcon} alt="info icon" />
        </DetailBadge>
        </SubDetailsContainer>
      </DetailsContainer>
      <Modal
        show={showEditModal}
        onHide={() => {
          setShowEditModal(false);
        }}
        centered
        className="employee-modal"
      >
        <EmployeeModal setShowModal={setShowEditModal} employeeData={employeeData} />
      </Modal>
      <Modal
        show={showDetailsModal}
        onHide={() => {
          setShowDetailsModal(false);
        }}
        centered
        className="employee-modal"
      >
        <EmployeeDetailsModal setShowModal={setShowDetailsModal} employeeData={employeeData} />
      </Modal>
      <Modal
        show={showInativeModal}
        onHide={() => {
          setShowInativeModal(false);
        }}
        centered
        className="employee-inative-modal"
      >
        <InativeModal
          employeeData={employeeData}
          close={() => {
            setShowInativeModal(false);
          }}
        />
      </Modal>
    </Container>
  );
}

export default Item;
